/**
 * Get the Set (cart drawer version).
 * No Add button — clicking a size button adds that variant straight to
 * cart, then dispatches the theme's own 'cart:refresh' event so Minimog's
 * built-in cart-items component refreshes the drawer sections in place
 * (header/body/footer only — never the whole drawer element, so the open
 * state is never lost).
 */

function addToCart(variantId) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
  }).then((res) => {
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  });
}

function initRow(row) {
  const picker = row.querySelector('[data-cts-size-picker]');
  if (!picker) return;
  const buttonsWrap = picker.querySelector('[data-cts-size-buttons]');
  const selectedLabel = picker.querySelector('[data-cts-size-selected]');
  const priceEl = row.querySelector('[data-cts-price]');
  const imageEl = row.querySelector('[data-cts-image]');
  const statusEl = row.parentElement.querySelector('[data-cts-status]');

  buttonsWrap.addEventListener('click', (event) => {
    const btn = event.target.closest('.size-picker__btn');
    if (!btn || btn.disabled) return;

    // Optimistic UI while the add/refresh runs.
    buttonsWrap.querySelectorAll('.size-picker__btn').forEach((b) => b.classList.remove('is-selected'));
    btn.classList.add('is-selected');
    selectedLabel.textContent = btn.dataset.size;
    if (priceEl) priceEl.textContent = '$' + (parseFloat(btn.dataset.price) / 100).toFixed(2);
    if (imageEl && btn.dataset.image) imageEl.src = btn.dataset.image;

    buttonsWrap.querySelectorAll('.size-picker__btn').forEach((b) => (b.disabled = true));
    if (statusEl) statusEl.hidden = true;

    addToCart(btn.dataset.variantId)
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(() => {
        if (statusEl) {
          statusEl.textContent = 'Something went wrong — try again.';
          statusEl.hidden = false;
        }
        buttonsWrap.querySelectorAll('.size-picker__btn').forEach((b) => (b.disabled = false));
      });
  });
}

function initAllRows() {
  document.querySelectorAll('[data-cts-row]').forEach(initRow);
}

initAllRows();

// Cart drawer content gets replaced wholesale after add/remove/quantity
// changes, so re-bind whenever the drawer's body changes.
const cartBody = document.querySelector('#MinimogCartDrawerBody');
if (cartBody) {
  new MutationObserver(initAllRows).observe(cartBody, { childList: true, subtree: true });
}
